export default {
  mailSent:
    "An email has been sent to your email address. The email has a confirmation token, please confirm your email address."
};
